import { BehaviorSubject } from 'rxjs';
import { StorageType } from '../enums';

export class StorableSubject<T> extends BehaviorSubject<T> {
  constructor(
    fallbackValue: T,
    private key: string,
    private storageType: StorageType = StorageType.SESSION
  ) {
    super(fallbackValue);
    this.initializeFromStorage();
  }

  private initializeFromStorage(): void {
    const storedValue = StorableSubject.getStoredValue<T>(this.key, this.storageType);
    if (storedValue !== null) {
      super.next(storedValue);
    }
  }

  private static getStorage(storageType: StorageType): Storage {
    return storageType === StorageType.LOCAL ? localStorage : sessionStorage;
  }

  private static getStoredValue<T>(key: string, storageType: StorageType): T | null {
    const storage = StorableSubject.getStorage(storageType);
    const item = storage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(`Error parsing JSON for key "${key}":`, error);
      return null;
    }
  }

  private storeValue(value: T): void {
    const storage = StorableSubject.getStorage(this.storageType);
    storage.setItem(this.key, JSON.stringify(value));
  }

  public override next(value: T): void {
    this.storeValue(value);
    super.next(value);
  }
}
